"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCourseById = void 0;
const getCourseById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("courses")
        .select("*")
        .eq("id", id)
        .single();
    if (error) {
        throw new Error(error.message);
    }
    return data;
};
exports.getCourseById = getCourseById;
